module.exports = __webpack_public_path__ + "static/img/son2_active.6da1224a.png";